import React, { useState } from 'react';
import { ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { useTheme } from './themeContext';

export default function ThemeToggleButton({ sx, textSx }) {
  const { mode, setAppearance } = useTheme();
  const [anchor, setAnchor] = useState(null);
  return <>
    <Tooltip title="Appearance" placement="right">
      <ListItem button sx={sx} onClick={event => setAnchor(event.currentTarget)}
        aria-label="Appearance" aria-haspopup="menu" aria-expanded={Boolean(anchor)}
        aria-controls={anchor ? 'appearance-menu' : undefined}>
        <ListItemIcon>
          {mode === 'dark' ? <DarkModeOutlinedIcon sx={{ fontSize: 19 }} /> : <LightModeOutlinedIcon sx={{ fontSize: 19 }} />}
        </ListItemIcon>
        <ListItemText primary="Appearance" sx={textSx} />
      </ListItem>
    </Tooltip>
    <Menu id="appearance-menu" anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
      MenuListProps={{ 'aria-label': 'Appearance' }}
      PaperProps={{ sx: { minWidth: 180, borderRadius: 2 } }}>
      {[
        { value: 'light', label: 'Light', icon: <LightModeOutlinedIcon fontSize="small" /> },
        { value: 'dark', label: 'Dark', icon: <DarkModeOutlinedIcon fontSize="small" /> },
      ].map(option => <MenuItem key={option.value} selected={mode === option.value}
        role="menuitemradio" aria-checked={mode === option.value}
        onClick={() => { setAppearance(option.value); setAnchor(null); }}>
        <ListItemIcon>{option.icon}</ListItemIcon>
        <ListItemText>{option.label}</ListItemText>
        {mode === option.value && <CheckRoundedIcon fontSize="small" sx={{ ml: 2 }} />}
      </MenuItem>)}
    </Menu>
  </>;
}
